type PrequelLogoProps = {
  className: string;
  kind?: "wordmark" | "logo";
};
const PrequelLogo = ({ className, kind = "wordmark" }: PrequelLogoProps) => {
  if (kind === "wordmark") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1229 203"
        fill="none"
        stroke="currentColor"
        className={className}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path
              d="M22.67,105.1v77.29H0V2.06H68.26c34.27,0,53.59,19.58,53.59,51.52S102.53,105.1,68.26,105.1ZM67.75,83.47c20.35,0,30.66-10,30.66-29.89S88.1,23.7,67.75,23.7H22.67V83.47Z"
              fill="#141414"
            />
            <path
              d="M265.59,182.39l-52.81-85H182.64v85H160V2.06h63.11c33,0,53.07,16.49,53.07,47.66,0,25.5-12.62,41-37.61,46.11l53.84,86.56ZM182.64,23.7v52h41c19.32,0,29.11-8.76,29.11-26s-9.79-26-29.11-26Z"
              fill="#141414"
            />
            <path d="M322.51,2.06H436.89V23.7H345.18V75.48H424V97.12H345.18v63.63h94.29v21.64h-117Z" fill="#141414" />
            <path
              d="M595.31,151.47l16.75,16.75-15.71,16.23L580.89,169c-11.59,10.31-25.76,15.46-42.25,15.46-20.61,0-37.35-8-50.49-23.7-13.14-16-19.58-38.9-19.58-68.53S475,39.67,488.15,24C501.29,8,518,0,538.64,0S576,8,589.13,24c13.14,15.71,19.58,38.64,19.58,68.26C608.71,116.18,604.33,136,595.31,151.47Zm-48.43-17,15.72-16.23,16,16.23c4.38-11.59,6.7-25.5,6.7-42.25,0-24.21-4.13-42-12.63-53.32-8.5-11.59-19.83-17.26-34-17.26s-25.5,5.67-34,17.26C496.14,50.23,492,68,492,92.22c0,48.44,18,70.59,46.63,70.59,10.56,0,19.58-3.09,26.79-9.27Z"
              fill="#141414"
            />
            <path
              d="M639.62,2.06h22.67V121.34c0,24.72,15.19,41.47,41.21,41.47s41.22-16.75,41.22-41.47V2.06h22.67V119.79c0,20.09-5.93,35.8-18,47.4s-27.31,17.26-45.86,17.26-33.74-5.67-45.85-17.26-18-27.31-18-47.4Z"
              fill="#141414"
            />
            <path d="M806.8,2.06H921.18V23.7H829.47V75.48H908.3V97.12H829.47v63.63h94.28v21.64h-117Z" fill="#141414" />
            <path d="M1076.51,182.39H961.87V2.06h22.67V160.75h92Z" fill="#141414" />
            <path d="M1105.35,203V182.39H1229V203Z" fill="#141414" />
          </g>
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 576"
        fill="none"
        stroke="currentColor"
        className={className}
      >
        <rect width="576" height="576" fill="#141414" />
        <path
          d="M101.06,174.86V252H78.43V72h68.15c34.19,0,53.48,19.54,53.48,51.43s-19.29,51.43-53.48,51.43Zm45-21.6c20.32,0,30.6-10,30.6-29.83S166.38,93.6,146.06,93.6h-45v59.66Z"
          fill="#fff"
        />
        <path
          d="M343.54,252l-52.71-84.86H260.74V252H238.12V72h63c32.92,0,53,16.46,53,47.57,0,25.46-12.6,40.89-37.54,46L370.29,252ZM260.74,93.6v51.94h40.89c19.28,0,29.06-8.74,29.06-26s-9.78-26-29.06-26Z"
          fill="#fff"
        />
        <path
          d="M189.26,452.57,206,469.28l-15.69,16.2-15.43-15.42c-11.57,10.28-25.71,15.42-42.17,15.42-20.57,0-37.29-8-50.4-23.65C69.17,445.88,62.74,423,62.74,393.43S69.17,341,82.29,325.28c13.11-15.94,29.83-23.91,50.4-23.91s37.29,8,50.4,23.91c13.12,15.69,19.54,38.57,19.54,68.15C202.63,417.34,198.26,437.14,189.26,452.57Zm-48.34-17,15.68-16.2,16,16.2c4.37-11.57,6.68-25.46,6.68-42.17,0-24.17-4.11-41.92-12.6-53.23-8.48-11.57-19.8-17.23-33.94-17.23s-25.46,5.66-33.95,17.23c-8.48,11.31-12.6,29.06-12.6,53.23,0,48.34,18,70.46,46.55,70.46,10.54,0,19.54-3.09,26.74-9.26Z"
          fill="#fff"
        />
        <path d="M361,483.43H246.6v-180h22.63v158.4H361Z" fill="#fff" />
        <path d="M389.83,504V483.43H513.26V504Z" fill="#fff" />
      </svg>
    );
  }
};

export default PrequelLogo;
